import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Language } from '../../interfaces/language.interface';
import { LANGUAGES } from '../../constants/languages.constants';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-selecionar-idioma',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './selecionar-idioma.component.html',
  styleUrl: './selecionar-idioma.component.css',
})
export class SelecionarIdiomaComponent implements OnInit {
  private static readonly STORAGE_KEY = 'preferencia_linguagem';

  @Input({ required: true }) exibirModal: boolean = false;
  @Output() modalEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  public readonly languages: readonly Language[] = LANGUAGES;
  public linguagemSelecionada: Language = LANGUAGES[0];

  constructor(
    private readonly elementRef: ElementRef,
    private readonly translocoService: TranslocoService,
  ) {}

  ngOnInit(): void {
    const storedLang =
      localStorage.getItem(SelecionarIdiomaComponent.STORAGE_KEY);

    const langToUse =
      storedLang ?? this.translocoService.getActiveLang();

    const found = this.languages.find(l => l.code === langToUse);

    if (found) {
      this.linguagemSelecionada = found;
      this.translocoService.setActiveLang(found.code);
    }
  }

  @HostListener('document:click', ['$event'])
  public lidarComClicksFora(event: MouseEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);

    if (!clickedInside && this.exibirModal) {
      this.fecharModal();
    }
  }

  public selecionarIdioma(language: Language): void {
    if (this.linguagemSelecionada.code === language.code) {
      return;
    }

    this.linguagemSelecionada = language;

    this.translocoService.setActiveLang(language.code);
    localStorage.setItem(
      SelecionarIdiomaComponent.STORAGE_KEY,
      language.code
    );
  }

  public fecharModal(): void {
    this.exibirModal = false;
    this.modalEmitter.emit(false);
  }
}
